<script>
import { fetchLobbying } from '../../api/feed';

export default {
  name: 'CpLawmakerActivity',
  components: {
    CpButton: require('../../button').default,
    CpButtonLink: require('../../button-link').default,
    CpGrid: require('../../grid').default,
    CpGridItem: require('../../grid-item').default,
    CpBox: require('../../box').default,
    CpBoxContent: require('../../box-content').default,
    CpPageContent: require('../../page-content.vue').default,
    CpTabs: require('../../inputs/tabs').default,
    CpTab: require('../../inputs/tab').default,
    CpSliceToggle: require('../../inputs/SliceToggle').default,
    CpYourActivity: require('../../user-profile/activity-content/YourActivity').default,
    CpCommentsPost: require('../../comments/box-comments').default,
  },
  directives: {
    margin: require('../../directives/margins').margin,
    marginTop: require('../../directives/margins').marginTop,
    marginRight: require('../../directives/margins').marginRight,
    marginBottom: require('../../directives/margins').marginBottom,
    marginLeft: require('../../directives/margins').marginLeft,
  },
  props: {
    user: Object,
    tab: String,
  },
  data() {
    return {
      hash: '',
      currentTab: this.tab,
      page: 0,
      lobbies: [],
      loading: false,
      comments_count: this.user.comments_count,
    };
  },
  created() {
    const category = window.location.hash.slice(1);
    this.hash = category;
    if (category !== '') {
      this.currentTab = category;
    }
  },
  mounted() {
    window.addEventListener('hashchange', this.onHashChange);
  },

  beforeDestroy() {
    window.removeEventListener('hashchange', this.onHashChange);
  },
  computed: {},
  methods: {
    onHashChange() {
      const newHash = window.location.hash.slice(1);
      this.hash = newHash;
    },
    reloadFromStart() {
      this.page = 0;
      this.lobbies = [];
      this.loadLobbies();
    },
    setDefaultLobbiesValues() {
      this.page = 0;
      this.lobbies = [];
    },
    loadLobbies($state = { loaded: () => {}, complete: () => {} }) {
      this.loading = true;
      fetchLobbying({ page: this.page, type_charge: 'official', official_id: this.user.id, type: 'all' })
        .then(response => {
          if (response.lobbies.length) {
            this.lobbies = this.lobbies.concat(response.lobbies);
            this.page += 1;
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch(error => {
          $state.complete();
          console.warn(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setCommentsCount(action) {
      action == 'remove' ? this.comments_count-- : this.comments_count++;
    },
  },
  watch: {
    tab(newVal) {
      this.currentTab = newVal;
    },
    hash(newVal) {
      if (newVal !== '') {
        this.currentTab = newVal;
        if (this.currentTab === 'comments') {
          this.setDefaultLobbiesValues();
        }
      }
    },
  },
};
</script>

<template>
  <CpPageContent>
    <CpTabs spaceBetween>
      <CpTab name="Constituent Activity" :selected="currentTab === 'constituent-activity'">
        <CpYourActivity :user="user" :activities="lobbies" :getActivities="loadLobbies" :loading="loading" />
      </CpTab>
      <CpTab name="Comments" :selected="currentTab === 'comments'" :disabled="comments_count === 0">
        <CpCommentsPost :id="user.id" type="officials" :setCount="setCommentsCount" />
      </CpTab>
    </CpTabs>
  </CpPageContent>
</template>
